export enum DoohReportErrorCode {
  ReportTooLarge = 'E_DOOH_REPORT_TOO_LARGE',
  ReportTimeout = 'E_DOOH_REPORT_TIMEOUT',
  ProviderUnavailable = 'E_DOOH_PROVIDER_UNAVAILABLE',
}
